var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyBrand(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 15.75H14.25",
    stroke: "#00424B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09375 9.5625H9M9.1875 9.5625C9.1875 9.66607 9.10357 9.75 9 9.75C8.89643 9.75 8.8125 9.66607 8.8125 9.5625C8.8125 9.45893 8.89643 9.375 9 9.375C9.10357 9.375 9.1875 9.45893 9.1875 9.5625Z",
    stroke: "#00424B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1864 5.70817L10.3559 4.03634C9.76425 2.84545 9.46845 2.25 9 2.25C8.53155 2.25 8.23575 2.84545 7.64415 4.03634L6.81362 5.70817C6.4358 6.4687 6.24689 6.84898 5.90982 6.93456C5.88638 6.94051 5.86267 6.94532 5.83877 6.949C5.49512 7.00178 5.17439 6.72508 4.53295 6.17171C3.0093 4.85726 2.24747 4.20003 1.78526 4.46174C1.75534 4.47868 1.7266 4.49765 1.69924 4.5185C1.27648 4.84079 1.57156 5.80602 2.16172 7.73647L3.03587 10.5959C3.35324 11.6341 3.51191 12.1532 3.9134 12.4516C4.31489 12.75 4.85446 12.75 5.9336 12.75L12.0665 12.7499C13.1456 12.7499 13.6851 12.7499 14.0866 12.4515C14.4881 12.1531 14.6468 11.634 14.9642 10.5959L15.8383 7.73647C16.4285 5.80603 16.7235 4.8408 16.3008 4.51851C16.2734 4.49765 16.2446 4.47868 16.2148 4.46174C15.7526 4.20004 14.9907 4.85727 13.4671 6.17172C12.8256 6.72509 12.5049 7.00178 12.1613 6.949C12.1373 6.94532 12.1136 6.94051 12.0902 6.93455C11.7531 6.84898 11.5642 6.4687 11.1864 5.70817Z",
    stroke: "#00424B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBrand);
export default __webpack_public_path__ + "static/media/my-brand.d588a8d5b3ab4050f45336dddfb46956.svg";
export { ForwardRef as ReactComponent };